import { render, staticRenderFns } from "./AggregatedReports.vue?vue&type=template&id=c7b52a10&"
import script from "./AggregatedReports.vue?vue&type=script&lang=js&"
export * from "./AggregatedReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports